import React from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import coursesData from "../data/coursesData";

export default function CoursesSection() {
    const { t } = useTranslation();

    const showData = coursesData.map((el, index) => (
        <div key={index} className="w-100 w-[30%] rounded-[4px] border border-[#09778E]">
            <div className="p-3">
                <div className="w-full h-[250px]">
                    <img className="w-full h-full rounded-t-[4px] object-cover" src={el.image} alt={el.coursesName} />
                </div>
                <div className="flex items-center justify-center gap-[8px] text-[#09778E] font-bold py-[15px]">
                    <span className="w-[15px] h-[15px] bg-[#A31D1C] rounded-full"></span>
                    <div className="font-bold text-[20px]">{t(`${el.coursesName}`)}</div>
                    <span className="w-[15px] h-[15px] bg-[#A31D1C] rounded-full"></span>
                </div>
            </div>
            <div className="bg-[#09778E] p-[15px] flex flex-col justify-between gap-[8px]">
                {el.coursesClasses.map((courseClass, classIndex) => (
                    <div key={classIndex}>
                        <Link
                            to={`/courses-portal/${el.coursesName.replace(/\s+/g, '-')}/${courseClass.coursesClassesTitle.replace(/\s+/g, '-')}`}
                            className="w-full bg-white flex items-center font-bold justify-center p-2.5 rounded-[4px] text-center text-[#09778E] hover:bg-[#09778E] hover:text-white transition-all duration-500 border-[1px] border-white"
                        >
                            {t(`${courseClass.coursesClassesTitle}`)}
                        </Link>
                    </div>
                ))}
            </div>
        </div>
    ));

    return (
        <section className="relative py-[40px]">
            <div className="container">
                {showData}
            </div>
        </section>
    );
}
